export default __webpack_public_path__ + "static/media/beb09649f9a0c006.d7322fd8db6df31adfb42ba810a88bb9.svg";